import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Users, Settings, FileText } from 'lucide-react';
import { usePermissions } from '../../hooks/usePermissions';

export default function SettingsLayout() {
  const { canManageUsers, canManageSystemSettings, canViewAuditLogs } = usePermissions();

  const navItems = [
    {
      to: 'users',
      icon: Users,
      label: 'User Management',
      permission: canManageUsers
    },
    {
      to: 'system',
      icon: Settings,
      label: 'System Settings',
      permission: canManageSystemSettings
    },
    {
      to: 'audit-logs',
      icon: FileText,
      label: 'Audit Logs',
      permission: canViewAuditLogs
    }
  ].filter(item => item.permission);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="mt-1 text-sm text-gray-500">
          Manage system settings and user access
        </p>
      </div>

      <div className="flex space-x-8">
        <nav className="w-48 flex-shrink-0">
          <ul className="space-y-1">
            {navItems.map(({ to, icon: Icon, label }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    `flex items-center px-3 py-2 text-sm font-medium rounded-md ${
                      isActive
                        ? 'bg-primary text-white'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`
                  }
                >
                  <Icon className="mr-3 h-5 w-5" />
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="flex-1">
          <div className="bg-white shadow rounded-lg">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}